module.exports = __webpack_public_path__ + "assets/svg/Icons/32/message-gray-37a9e0.svg";